import * as LabelPrimitive from "@radix-ui/react-label";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/utils/cn";

export type LabelProps = ComponentPropsWithoutRef<typeof LabelPrimitive.Root>;

/**
 * Label i aksesueshem per fushat e formave.
 */
export const Label = ({ className, ...props }: LabelProps): JSX.Element => (
  <LabelPrimitive.Root className={cn("text-sm font-medium text-foreground", className)} {...props} />
);
